<template>
  <div class="home-page cg-page">
    <div class="login-content">
      <div class="pt20 disflex" style="justify-content: center;position: fixed;background:url(static/images/star.png) no-repeat 0 0;max-width:750px;height: 317px;background-size: cover;align-items: flex-start;">
        <a class="logo" style="width: 150px;margin: 0 30px;" href="/"><img src="static/images/logo1.png" /></a>
      </div>
      <div class="landing-page">
        <div>
          <div class="home-prize" style="padding-top: 185px;">
            <div class="home1 ac">
              <img :src="isEN=='bur' ? '../../static/images/login-bg4.png' : '../../static/images/login-bg4.png'">
            </div>
          </div>
          <div>
            <div class="lg-bg2">
              <div class="ac mt30">
                <div class="drown-list drown-bg">
                  <div class="disflex package-wrap">
                    <div class="drown-li" @click="goPackage('http://gwk.gbgts.com/gt/consent?subAppId=day1')">
                      <div class="disflex package-btn">
                        <span>{{$t('1_day')}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="disflex package-wrap package-wrap-second">
                    <div class="drown-li" @click="goPackage('http://gwk.gbgts.com/gt/consent?subAppId=day2')">
                      <div class="disflex package-btn">
                        <span>{{$t('2_day')}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="switch-link ac">
                    <span @click="goLogin">{{$t('hasAccountGoLogin')}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="footer-content ac" style="justify-content: space-evenly;">
              <div class="icon icon2" @click="getHref('faq')">
                <img src="../../static/images/menu-icon5.png" />
                <span>{{$t('FAQs')}}</span>
              </div>
              <div class="icon icon3" @click="getHref('termsAndCondition')">
                <img src="../../static/images/menu-icon6.png" />
                <span>{{$t('TC')}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isEN: 'bur'
    }
  },
  created() {
    if (localStorage.getItem('lang')) this.isEN = localStorage.getItem('lang')
  },
  methods: {
    getHref(type) {
      this.$router.push({ path: type, query: { type: type } })
    },
    goLogin() {
      this.$router.push({ path: '/login' })
    },
    goPackage(url) {
      window.location.href = url
    }
  }
}
</script>
<style scoped>
.drop-down-content{z-index:9;background:none;}
.landing-page{padding-bottom:60px;}
.cg-page{background: url(../../static/images/bg3-png.jpg) no-repeat center top #0034ae;}
.drown-list{width: auto;margin-top: -40px;}
.drown-bg .drown-li.active::before,.drown-bg .drown-li::before{display: none;}
.drown-list .disflex{font-size: 30px;font-weight: 700;box-shadow: none;background-color: none;text-shadow: #000000 -5px 2px;margin-top: 20px;}
.lg-bg2{background:url(../../static/images/login-img3.png) no-repeat center 70px;}
.package-wrap{margin-top: 32px;justify-content: center;}
.package-wrap-second{margin-top: 18px;}
.package-btn{background: url(../../static/images/login.png) no-repeat;background-size: contain;min-height: 100px;width: 320px;}
.switch-link{margin-top: 24px;font-size: 26px;color: #fff;}
.switch-link span{cursor: pointer;text-decoration: underline;}
</style>



// WEBPACK FOOTER //
// src/page/reg.vue